// components/RejectReasonModal.jsx
import { Modal, Button, Form } from "react-bootstrap";

export default function RejectReasonModal({
                                              open,                // bool
                                              onClose,             // () => void
                                              onConfirm,           // () => void
                                              reason,              // string (rejectReason)
                                              onChangeReason,      // (value) => void
                                              title = "Motivo de Rechazo",
                                          }) {
    const canConfirm = !!(reason && reason.trim());

    return (
        <Modal show={open} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>¿Por qué se rechaza esta solicitud?</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={reason}
                        onChange={(e) => onChangeReason?.(e.target.value)}
                        placeholder="Escribe aquí el motivo..."
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Cancelar</Button>
                <Button variant="danger" onClick={onConfirm} disabled={!canConfirm}>
                    Confirmar Rechazo
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
